import { useMemo } from "react";
import createHeartComponent from "@finn-no/favorite-heart-component";
import { useExternalProps } from "./ExternalPropsProvider.js";

export const useHeart = () => {
	const { favoriteBaseUrl, loginId } = useExternalProps();

	const Heart = useMemo(
		() =>
			createHeartComponent({
				baseUri: favoriteBaseUrl ?? "",
				userId: loginId ?? "",
				modalAttach: document.querySelector("aurora-mobility-recommendations-podlet-isolated")!
					.shadowRoot as unknown as HTMLElement,
			}),
		[favoriteBaseUrl, loginId],
	);

	return { Heart };
};
